'use client'
import React from 'react'
import Link from "next/link";
import { useState } from "react";
import Image from 'next/image';

const Layout = ({ posts }: { posts: Array<any> }) => {
    const [searchQuery, setSearchQuery] = useState("");
    const [currentPage, setCurrentPage] = useState(1);


    const sortedPosts = [...posts].sort((a, b) => {
        return new Date(b.frontMatter.date).getTime() - new Date(a.frontMatter.date).getTime();
    });

    const filteredPosts = sortedPosts.filter((post) =>
        post.frontMatter.title.toLowerCase().includes(searchQuery.toLowerCase())
    );



    const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchQuery(e.target.value);
        setCurrentPage(1);
    };

    const [visiblePosts, setVisiblePosts] = useState(9);

    const handleShowMore = () => {
        setVisiblePosts((prev) => prev + 9); // Increase by 9 posts when "Show More" is clicked
    };

    return (
        <>
            <section className="page-section" id="blog">
                <div className="container position-relative">
                    <div className="row gx-5 mt-n50 mt-sm-n30 mb-50 mb-sm-30 ">
                        <div
                            className="offcanvas__search"
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                width: '100%',
                                height: '100%'
                            }}
                        >
                            <input
                                type="text"
                                value={searchQuery}
                                onChange={handleSearch}
                                placeholder="Search blog..."
                                style={{
                                    width: '100%',
                                    maxWidth: '400px',
                                    padding: '0.5rem',
                                    border: '1px solid #ccc',
                                    borderRadius: '0.375rem'
                                }}
                            />
                        </div>

                        {filteredPosts.slice(0, visiblePosts).map((post, i) => (
                            <div
                                key={i}
                                className="post-prev-2 col-md-6 col-lg-4 mt-50 mt-sm-30 transform scale-95 transition-transform duration-300 ease-in-out hover:scale-100 hover:shadow-lg"
                            >
                                <div className="border border-black p-2 rounded-lg">
                                    <div className="post-prev-2-img">
                                        <a href={`/blog/${post.slug}/`}>
                                            <Image
                                                src={post.frontMatter.ogimage}
                                                width={1200}
                                                height={630}
                                                className="rounded-lg"
                                                alt={post.frontMatter.slug}
                                            />
                                        </a>
                                    </div>
                                    <h3 className="post-prev-2-title clamp-2-lines">
                                        <Link href={`/blog/${post.slug}/`}>
                                            {post.frontMatter.title}
                                        </Link>
                                    </h3>

                                    <div className="post-prev-2-info">{post.frontMatter.date}</div>
                                </div>
                            </div>

                        ))}
                    </div>
                    {searchQuery !== '' && filteredPosts.length === 0 && (
                        <div className="text-center my-10 text-gray-500">
                            No results found.
                        </div>
                    )}

                    {filteredPosts.length > 3 && visiblePosts < filteredPosts.length && (
                        <div className="text-center mb-10">
                            <button
                                onClick={handleShowMore}
                                className="btn btn-mod btn-large btn-round"
                            >
                                Show More
                            </button>
                        </div>
                    )}

                </div>
            </section>

        </>
    )
}

export default Layout